import { Action } from '../apis';

const NAVIGATION_SELECTOR = 'a[href]';

export const resolveAction = (host: Element): Action | undefined => {
  const declared = host.getAttribute('data-track-action');
  if (declared) {
    return declared as Action;
  }
  const expanded = host.getAttribute('aria-expanded');
  if (expanded === 'false') {
    return 'expand';
  }
  if (expanded === 'true') {
    return 'collapse';
  }
  return host.matches(NAVIGATION_SELECTOR) ? 'navigate' : undefined;
};
